import {omneticApi} from '@dms/api/base';

import {
  GetPayPerUseLeaderboardApiArg,
  GetPayPerUseLeaderboardApiResponse,
  getPayPerUseLeaderboardApiArgSchema,
  GetPayPerUseMetricsApiArg,
  GetPayPerUseMetricsApiResponse,
  getPayPerUseMetricsApiArgSchema,
  payPerUseLeaderboardResponseSchema,
  payPerUseMetricsResponseSchema,
} from './types';

const payPerUseApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getPayPerUseMetrics: build.query<GetPayPerUseMetricsApiResponse, GetPayPerUseMetricsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/pay-per-use/metrics`,
        params: {month: queryArg.month},
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'PayPerUseMetrics', id: 'LIST'},
        {type: 'PayPerUseMetrics', id: queryArg.month},
      ],
      extraOptions: {
        requestSchema: getPayPerUseMetricsApiArgSchema,
        responseSchema: payPerUseMetricsResponseSchema,
      },
    }),
    getPayPerUseLeaderboard: build.query<
      GetPayPerUseLeaderboardApiResponse,
      GetPayPerUseLeaderboardApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/pay-per-use/leaderboard`,
        params: {month: queryArg.month},
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'PayPerUseLeaderboard', id: 'LIST'},
        {type: 'PayPerUseLeaderboard', id: queryArg.month},
      ],
      extraOptions: {
        requestSchema: getPayPerUseLeaderboardApiArgSchema,
        responseSchema: payPerUseLeaderboardResponseSchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {useGetPayPerUseMetricsQuery, useGetPayPerUseLeaderboardQuery} = payPerUseApi;
